export const COLORS = {
  // colors from Audi color palette
  // https://react.ui.audi/?path=/story/brand-identity-colors--page
  white: '#ffffff',
  black: '#000000',
  audiRed: '#bb0a30',
  grey5: '#f2f2f2',
  grey10: '#e5e5e5',
  grey15: '#d9d9d9',
  grey20: '#cccccc',
  grey30: '#b3b3b3',
  grey40: '#999999',
  grey50: '#808080',
  grey60: '#666666',
  grey70: '#4c4c4c',
  grey80: '#333333',
  grey90: '#1a1a1a',
  // new colors
  audiWarmSilver: '#b6b1a9',
  audiDarkGray: '#4a4a4a',
  redRibbon: '#EB0D3F',
  flashOfOrange: '#FFAA00',
  spaceInvader: '#0DA20D',
};

type ColorKeys = keyof typeof COLORS;

export type Color = (typeof COLORS)[ColorKeys];

export const SIZING = {
  unit: (times: number): string => `${times * 8}px`,
};
